import {Box, Typography} from "@mui/material"
import React from "react"
import {nanoid} from "nanoid"
import Widget from "../../../src/components/Widget";

const widgetFromMerkmalGenerator = (merkmal) => {
    const id = nanoid()
    return {
        id: id,
        label: merkmal.label,
        x: 0,
        y: 1,
        w: 1,
        h: 1,
        component: merkmal.antworttyp,
        connections: {
            id: merkmal.id,
            treeName: "attributes",
            origin: merkmal,
        },
        i: id,
        moved: false,
        static: false,
    }
}

const ContainerQSList = ({getDataFromPointer}) => {
    const merkmale = getDataFromPointer("/qsList")

    return (
       merkmale && <Box
            display="grid"
            gridTemplateColumns="2fr 2fr 1fr"
            gap="5px"
            padding="5px"
            alignItems="center"
        >
            {merkmale.map((merkmal) => (
                <>
                    <Typography>{merkmal.origin.question}</Typography>
                    <Box>
                        <Widget
                            widget={widgetFromMerkmalGenerator(
                                merkmal.origin,
                            )}
                        />
                    </Box>
                    <Typography>{merkmal.weight}</Typography>
                </>
            ))}
        </Box>
    )
}

export default ContainerQSList
